import dayjs from '@sancare/typescript-commons/src/misc/dayjs'

import { StayAction, StayActionDtoIn } from '@/store/modules/stay/mco/types'

export function convertMcoStayActionIn(rawStayAction: StayActionDtoIn): StayAction {
  return {
    ...rawStayAction,
    creationDate: dayjs(rawStayAction.creationDate),
  }
}
